<template>
  <section class="listing">
    <div class="header">
      <div class="title">Convites</div>
      <button @click="$router.push('/invitation/new')" class="button-save"><i class="fas fa-paper-plane"></i><span>Convidar</span></button>
    </div>
    <form @submit.prevent class="form form-search">
      <div class="search-input">
        <input v-model="search" type="text" placeholder="Pesquisar..." />
        <i class="fas fa-search show-search"></i>
      </div>
      <div class="form-search">
        <select v-model="sentBy" style="width: 200px">
          <option value="">Todos</option>
          <option value="P">Produtor (P)</option>
          <option value="E">Estabelecimento (E)</option>
        </select>
      </div>
    </form>
    <transition name="show" mode="out-in">
      <i v-if="loading" class="fas fa-spinner loading-big"></i>
      <div v-if="!loading">
        <div class="sum-group">
          <div class="sum">
            <span>Convites emitidos</span>
            <span>{{ filtered.length }}</span>
          </div>
          <div class="sum">
            <span>Convites aceitos</span>
            <span>{{ used }}</span>
          </div>
        </div>
        <div v-for="(s, i) in filtered" :key="s.id" class="list">
          <div v-if="i > 0 ? getDay(s.date) !== getDay(filtered[i - 1].date) : true" class="calendar">
            <span>{{ getDay(s.date) }}</span>
            <span>{{ getMonthText(s.date) }}</span>
          </div>
          <div v-if="i > 0 ? getDay(s.date) === getDay(filtered[i - 1].date) : false" style="width: 50px"></div>
          <div class="time-text">
            <span>{{ getHours(s.date) }}</span>
            <span>{{ getMinutes(s.date) }}</span>
          </div>
          <div class="data">
            <div class="main-data">{{ s.customer }}</div>
            <div class="detail-data">{{ s.show }}</div>
          </div>
          <div class="data" style="text-align: right; padding-right: 20px">
            <div class="main-data">{{ s.email }}</div>
            <div class="detail-data">{{ s.type === 'fixed' ? `Ingresso por R$ ${s.discount.toLocaleString('pt-br', { minimumFractionDigits: 2 })}` : `Desconto ${s.type === 'percent' ? `${s.discount.toFixed(0)}%` : `R$ ${s.discount.toLocaleString('pt-br', { minimumFractionDigits: 2 })}`} válido até ${s.expiration}`}} {{s.producer ? '(P)' : '(E)'}} </div>
          </div>
          <div class="data" style="flex-grow: 0; padding-right: 20px">
            <i class="fas fa-check" :style="{ color: !!s.ticket ? 'green' : 'transparent' }"></i>
          </div>
          <div class="actions">
            <button @click="resendInvite(s.id)" type="button" class="button-action">
              <template v-if="resending === s.id"><i class="fas fa-spinner loading-big"></i><span>ENVIANDO</span></template>
              <template v-else><i class="fas fa-paper-plane"></i><span>ENVIAR</span></template>
            </button>
          </div>
        </div>
      </div>
    </transition>
    <Invitation v-if="invitation" :id="invitation" />
  </section>
</template>

<script>
import { mapState } from 'vuex'
import logger from '../../logger'
import { getAll, resend } from '../api/invitation'
import Invitation from './Invitation.vue'

export default {
  name: 'invitations',
  components: { Invitation },
  props: ['id'],
  data () {
    return {
      loading: true,
      invitations: [],
      invitation: null,
      search: '',
      resending: false,
      sentBy: ''
    }
  },
  computed: {
    ...mapState(['business']),
    filtered () {
      return this.invitations.filter(x =>
        Object.keys(x).some(key =>
          String(x[key]).toUpperCase().includes(this.search.toUpperCase())
        )
      // eslint-disable-next-line no-return-assign
      ).filter(x =>
        x = this.sentBy === 'P' ? x.producer !== null : this.sentBy === 'E' ? x.producer === null : x
      )
    },
    used () {
      return this.filtered.filter(x => !!x.ticket).length
    }
  },
  watch: {
    async '$route' (value) {
      this.invitation = value.name === 'invitation-id' ? value.params['id'] : null
      if (!value.params['id']) {
        this.getData()
      }
    }
  },
  async mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.loading = true
      try {
        const invitations = await getAll()
        this.invitations = invitations
      } catch (error) {
        logger.warn(error)
      }
      this.loading = false
    },
    async resendInvite (id) {
      if (this.resending === id) return false
      this.resending = id
      try {
        await resend(id)
      } catch (error) {
        logger.warn(error)
      }
      this.resending = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.list-title {
  border: 1px solid $primary-color;
  border-radius: 5px;
  // color: $primary-color;
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  color: #fff;
  padding: 5px 10px;
  margin: 15px 0 5px;
}

.form-search {
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0;
  padding-bottom: 10px;

  .search-input input {
    width: 100%;
    height: 34px;
    margin: 5px;
  }

  .search-input {
    flex: 1;
    min-width: 200px;
    position: relative;
    margin: 5px;
    input {
      display: block;
      width: 100%;
      margin: 0;
    }
    i {
      position: absolute;
      top: 6px;
      right: 10px;
      color: #999;
      font-size: 1.5em;
    }
  }
}

.calendar {
  width: 40px;
  height: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  border-radius: 5px;
  margin-right: 10px;
  font-weight: 500;
  span:nth-child(1) {
    font-size: 1.2em;
  }
  span:nth-child(2) {
    font-size: 0.7em;
  }
}

.time-text {
  font-size: 2.2em;
  font-weight: 400;
  padding-right: 20px;
  color: #555;
  display: flex;
  span:nth-child(2) {
    font-size: 0.5em;
    line-height: 2em;
  }
}

.sum-group {
  display: flex;
  flex-wrap: wrap;
  .sum {
    display: flex;
    flex-basis: calc(100% - 10px);
    margin: 0 5px 10px;
    span {
      text-align: center;
      padding: 8px 0;
      flex-basis: 50%;
    }
    span:nth-child(1) {
      color: #fff;
      background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
      border-radius: 5px 0 0 5px;
      border: 1px solid $secondary-color;
    }
    span:nth-child(2) {
      font-weight: bold;
      color: $secondary-color;
      border-radius: 0 5px 5px 0;
      border: 1px solid $secondary-color;
    }
  }
}

@media screen and (min-width: $desktop-width) {

  .form-search {
    input {
      width: auto;
    }
  }

  .sum-group {
    .sum {
      flex-basis: calc(50% - 10px);
    }
  }

}
</style>
